import { Injectable } from '@angular/core';
import { isNull, isEmptyString } from '../util/check';
import { FnFileConstant } from '../constant/fn-file-type.constant';

@Injectable()
export class FnFileService {
	public getBaseType(fileType: string) {
		let type = 'other';
		const baseKeys = Object.keys(FnFileConstant.FILE_TYPES);
		for (let i = 0; i < baseKeys.length; i++) {
			if (FnFileConstant.FILE_TYPES[baseKeys[i]].indexOf(fileType) !== -1) {
				type = baseKeys[i];
				break;
			}
		}
		return type;
	}
	public getIcons(mimeType: string, isUnencrypted?: boolean) {
		if (isNull(mimeType) || isEmptyString(mimeType)) {
			return FnFileConstant.FILE_TYPE_ICONS.other;
		}

		if (!isUnencrypted) {
			mimeType = mimeType.split(':')[1].split(';')[0].toLowerCase();
		}

		const fileBaseType = mimeType.split('/');
		if (FnFileConstant.BASE_TYPES.indexOf(fileBaseType[0]) !== -1) {
			return FnFileConstant.FILE_TYPE_ICONS[fileBaseType[0]];
		} else {
			return FnFileConstant.FILE_TYPE_ICONS[this.getBaseType(fileBaseType[1])];
		}
	}


     downloadUint8File(fileObject:any, mimeString:string, fileName:string) {
        const blob = new Blob([new Uint8Array(fileObject)], {type: mimeString});
        let a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a)
    }
    
    downloadBlobFile(fileObject:any, mimeString:string, fileName:string) {
        const blob = new Blob([fileObject], {type: mimeString});
        let a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a)
    }
    
      getArrayBufferFromBase64(base64Str:string) {
        base64Str = base64Str.replace(/\s/g, '');
        const binary_string = window.atob(base64Str);
        const len = binary_string.length;
        let bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }
    
     getBase64ByteString(bufferArray:any) {
        const uint8Array = new Uint8Array(bufferArray);
        let str = "";
        for (let i = 0; i < uint8Array.length; i++) {
            str += String.fromCharCode(uint8Array[i]);
        }
        return window.btoa(str);
    }
    
    // download encoded bytes
     downloadEncodedBytesFile(fileObject:any, mimeString:string, fileName:string) {
        const bufferArray = this.getArrayBufferFromBase64(fileObject);
        const blob = new Blob([bufferArray], {type: mimeString});
        let downloadLink = document.createElement('a');
        
        	downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = fileName; 
            document.body.appendChild(downloadLink);
            setTimeout( () =>{
                downloadLink.click();
                downloadLink.remove();
            }, null);	
         
        
    }

    base64ToBlob(base64: string, type: string): Blob {
        const binaryString = window.atob(base64);
        const _length = binaryString.length;
        const bytes = new Uint8Array(_length);

        for (let i = 0; i < _length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        return new Blob([bytes], { type });
    }

}
